import { useMemo } from "react";
import { useTheme } from "@fluentui/react/lib/Theme";
import { IStyleSet, mergeStyleSets } from "@fluentui/react/lib/Styling";

import { textOverflow } from "Utils/Styles";

const classNames = {
  root: `KeyValueGridRoot`,
  headerWrap: `KeyValueGridHeaderWrap`,
  header: `KeyValueGridHeader`,
  content: `KeyValueGridContent`,
  row: `KeyValueGridRow`,
  rowAlt: `KeyValueGridRowAlt`,
  label: `KeyValueGridLabel`,
  labelRequired: `KeyValueGridLabelRequired`,
  value: `KeyValueGridValue`,
  tooltip: `KeyValueGridToolTip`
};

export function useKeyValueGridStyles(styleSet: IStyleSet) {
  const { spacing, semanticColors } = useTheme();
  return useMemo(
    () => mergeStyleSets(
      {
        root: [
          classNames.root,
          {
            width: `100%`,
            height: `100%`
          }
        ],
        headerWrap: [
          classNames.headerWrap,
          {
            width: `100%`,
            paddingBottom: spacing.m,
            ...textOverflow
          }
        ],
        header: [
          classNames.header,
          {
            fontWeight: 600
          }
        ],
        content: [
          classNames.content,
          {
            width: `100%`
          }
        ],
        row: [
          classNames.row,
          {
            width: `100%`,
            overflow: `hidden`
          }
        ],
        rowAlt: [
          classNames.rowAlt,
          {
            width: `100%`,
            overflow: `hidden`
          }
        ],
        label: [
          classNames.label,
          {
            padding: `1px 0`,
            width: `110px`,
            ...textOverflow,
            "& .ms-Label": {
              display: `inline`,
              fontWeight: `normal`,
              paddingRight: `3px`,
              selectors: {
                "::after": {
                  content: `unset`
                }
              }
            }
          }
        ],
        labelRequired: [
          classNames.labelRequired,
          {
            "& .ms-Label": {
              selectors: {
                "::before": {
                  content: `'*'`,
                  color: semanticColors.errorText,
                  paddingRight: `5px`
                }
              }
            }
          }
        ],
        value: [
          classNames.value,
          {
            ...textOverflow
          }
        ],
        tooltip: [
          classNames.tooltip,
          {
            display: `block`
          }
        ]
      },
      styleSet
    ),
    [semanticColors, spacing, styleSet]
  );
}
